import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { PctableStockComponent } from '../../components/pctable-stock/pctable-stock.component';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BuyImportRequestDrugModal } from '../../models/buy-import-modal';
import { WarehouseModal } from '../../models/warehose-modal';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import {
  BackendSellDrugItemModel,
  BackendSellModel,
  SelectDrug,
} from '../../models/select-drug';
import { SelectDrugChangePrice } from '../../models/select-drug-change-price';
import * as _ from 'lodash-es';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NewCalendarService } from 'src/app/services/new-calender-service';

@Component({
  selector: 'app-transfer-between-stock',
  templateUrl: './transfer-between-stock.component.html',
  styleUrls: ['./transfer-between-stock.component.css'],
})
export class TransferBetweenStockComponent {
  catalogs: any;
  public constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    private calendarService:NewCalendarService,
    private modalService: NgbModal,
    private responseService: CustomizeResponseService
  ) {
    // this.getEntity();
    this.requestModel = new PCSearchRequestModel();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      'TransferBetweenStock',
      []
    );

    this.thisItemOnStock = new WarehouseModal(
      '',
      0,
      '',
      '',
      0,
      '',
      '',
      '',
      '',
      ''
    );
    this.getStocks();
  }
  @ViewChild('barcode') barcodeElement!: ElementRef;
  @ViewChild('modalContent') modalContent!: any;
  @ViewChild(PCTableComponent) pCTableComponent!: PCTableComponent;
  public modalWarehouseIsOpen: boolean = false;

  public backendJson: any = {};

  public endPoint: string = `InventoryDetail`;
  public endPointUrl!: string;
  public data?: PCTableInputModel;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: any[] = [];

  public stocks: any[] = [];
  public thisStock: string = '';

  public stockList: any[] = [];
  public newItem: any = { count: '', stockId: '' };

  public InventoryList!: any;
  public listLoading: boolean = true;
  public factorId: string = '';
  public barcode: string = '';
  public dateTime: any;
  public finalDrugList: any[] = [];
  public level: number = 1;

  public loading: boolean = true;
  public modalLoading: boolean = false;
  public requestModel: PCSearchRequestModel;

  public sourceStockSelected: any;
  public destinationStockSelected: any;

  public selectDrugList: SelectDrug[] = [];

  public shakeFrom: boolean = false;
  public countMessage: string = ``;
  public destinationMessage: string = ``;
  public modalSuccessConfirm: boolean = false;
  public packageCount: number = 0;

  public editableItem: BuyImportRequestDrugModal =
    new BuyImportRequestDrugModal(this.calendarService.GetNow());

  public thisItemOnStock: WarehouseModal;

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.listLoading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }
        this.requestModel.orderBy = event.data;
        this.getSingleData();
        break;
      case 'Search':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.getSingleData();
        break;
      case 'Paging':
        this.listLoading = true;

        this.requestModel.pageNumber = event.data;
        this.getSingleData();
        break;
      case 'PageSize':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.getSingleData();
        break;
      case 'Reload':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.getSingleData();
        break;
      case 'ReteyListView':
        this.listLoading = true;
        this.getSingleData();
        break;
      case 'TransferModalClose':
        this.modalWarehouseIsOpen = false;
        break;
      case 'PrintItem':
        this.getDetailPrint(event.data.id);
        break;
      case 'Create':
        this.goToAddPage('listCard');
        break;
      case 'SelectItem':
        this.modalWarehouseIsOpen = true;
        this.thisItemOnStock = _.cloneDeep(event.data);
        this.countKeyUp();
        break;
      default:
        break;
    }
  }

  public goToAddPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }
    this.selectDrugList = [];
    this.backendJson = new BackendSellModel();

    setTimeout(() => {
      this.level = 1;
    }, 700);

    setTimeout(() => {
      this.barcodeElement.nativeElement.focus();
    }, 2 * 1000);
  }

  public goToViewPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 3;
    }, 700);
  }

  public getDetailPrint(itemID: string) {
    try {
      this.listLoading = true;
      let url = `${this.endPoint}/Print/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.goToViewPage('addCard');
            this.factorId = result.data.factorId;
            this.barcode = result.data.barcode;
            this.dateTime = result.dateTime;
            this.backendJson.TotalPrice = result.data.finalPayment;
            this.finalDrugList = result.data.prescriptions;
            this.goToViewPage('listCard');
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }

  public getStocks(): void {
    try {
      let url = `Stock`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.title,
            }));
            if (this.stockList != null) {
              this.sourceStockSelected = this.stockList[0].id;
            }
            forkJoin([this.getData(), this.getEntity()]).subscribe(
              ([dataResult, entityResult]) => {
                if (dataResult) {
                  if (dataResult.succeeded) {
                    let firstItemOnPage = 1;
                    if (dataResult.data?.firstItemOnPage) {
                      firstItemOnPage = dataResult.data?.firstItemOnPage;
                    }

                    if (
                      dataResult.data?.pageCount! < dataResult.data?.pageNumber!
                    ) {
                      this.requestModel.pageNumber = 1;
                    }

                    this.data = new PCTableInputModel(
                      dataResult.data?.items,
                      [],
                      true,
                      firstItemOnPage,
                      this.requestModel.orderBy,
                      this.requestModel.direction
                    );

                    this.paging =
                      this.responseService.customizePaging(dataResult);
                  }
                }

                if (entityResult) {
                  this.logger.addResponseLog(
                    this.endPoint == null ? '' : this.endPoint,
                    entityResult,
                    `Get Entity`
                  );
                  if (entityResult.succeeded) {
                    let fields = this.apiService.convertStringToBoolean(
                      entityResult.data.fields
                    );

                    fields.forEach((element) => {
                      element.camelCaseName = this.apiService.camelCase(
                        element.fieldName
                      );
                    });

                    this.fields = fields;
                  }
                }

                setTimeout(() => {
                  this.pCTableComponent.InitPage();
                }, 20);

                this.loading = false;
              },
              (error) => {
                this.apiService.AddErrorLog(error);
                this.loading = false;
              }
            );
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public getData() {
    this.generateUrl();
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          this.endPoint
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public getSingleData() {
    try {
      this.generateUrl();

      this.loading = true;
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);

            setTimeout(() => {
              this.pCTableComponent.InitPage();
            }, 20);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public searchStockName(id?: string): string {
    var result = `N/A`;

    if (id == null) {
      return result;
    }

    var foundedStock = this.stockList.find((current) => current.id == id);

    if (foundedStock == undefined) {
      return result;
    }
    return foundedStock.persianName;
  }

  private generateUrl() {
    this.endPointUrl = `${this.endPoint}/Search?stockId=${this.sourceStockSelected}&search=${this.requestModel.search}&pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}`;
  }

  public getCheckInventory(id: any) {
    try {
      this.loading = true;

      let url = `InventoryDetail/ListView/${id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (result.data == null) {
              return;
            }
            this.InventoryList = result.data.map(
              (current) =>
                new WarehouseModal(
                  current.id,
                  current.count,
                  current.expireDate,
                  current.drugId,
                  current.packageCount,
                  current.companyName,
                  current.brandName,
                  current.stockName,
                  current.stockId,
                  current.id
                )
            );
            this.loading = false;
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkValidation() {
    if (this.backendJson.count > this.backendJson.maxTransfer) {
      this.countMessage = `مقدار انتقال از مقدار موجودی بیشتر است`;
      this.backendJson.count = this.backendJson.maxTransfer;
    } else if (this.backendJson.count <= 0) {
      this.countMessage = `مقدار انتقال نمیتواند کوچکتر از 1 باشد`;
      this.backendJson.count = this.backendJson.packageCount;
    }

    this.countMessage = ``;
  }

  public submitModal() {
    try {
      this.modalLoading = true;

      let url = `InventoryDetail/Transfer`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.loading = false;
        return;
      }

      var jsonText = JSON.stringify(this.backendJson);
      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            this.modalLoading = false;
            if (result.succeeded) {
              this.modalService.dismissAll();

              this.modalSuccessConfirm = true;
            }
            this.getSingleData();
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {
            this.modalLoading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
    }
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public countKeyUp(): boolean {
    this.checkValidation();

    if (this.backendJson.count % this.backendJson.drugPackageCount != 0) {
      if (this.countMessage == ``) {
        this.countMessage = `مغایرت در بسته بندی`;
      }
      return false;
    } else {
      this.packageCount =
        this.backendJson.count / this.backendJson.drugPackageCount;
      return true;
    }
  }

  public beTrue() {
    if (!this.countKeyUp()) {
      this.packageCount =
        this.backendJson.count / this.backendJson.drugPackageCount -
        (this.backendJson.count % this.backendJson.drugPackageCount) /
          this.backendJson.drugPackageCount;
      this.backendJson.count =
        this.packageCount * this.backendJson.drugPackageCount;
    }
  }

  public packageKeyUp() {
    this.backendJson.count =
      this.packageCount * this.backendJson.drugPackageCount;

    this.checkValidation();
  }
}
